import { put } from '../api.service';

// Shared API service for version preference
export const updateVersionPreference = async (versionType: 1 | 2) => {
  try {
    await put(`/userpreference/version?versionType=${versionType}`, {});
    return true;
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};

// Persist the user's preferred language (e.g. 'en-us', 'sv-se')
export const updateLanguagePreference = async (lang: string) => {
  try {
    await put(`/userpreference/language?lang=${encodeURIComponent(lang)}`, {});
    return true;
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};